/**
 * TT-935: "How to work with Amira" intro videos shown at the start of the Ready Module.
 *
 * Three videos, each in English and Spanish: one for Assess, and two for Tutor split by
 * grade. Note the Tutor split is K-3 / 4-8, which is what the enablement team produced —
 * the ticket's original ACs say K-2 / 3-8 and are out of date.
 *
 * The files live under `videos/` in the shared-services `amira-assets-cdn` bucket, which
 * is what assets.app.amiralearning.com fronts (dev2, prod2, Canada), and in the legacy
 * `amira-assets` bucket behind prod and stage. Built off ASSET_ROOT so each stack serves
 * from its own CDN.
 */
const ASSET_ROOT = process.env.ASSET_ROOT || 's3.amazonaws.com/amira-assets'
const ASSET_BASE = `https://${ASSET_ROOT}/videos`

/**
 * All six assets are 1280x720, and IntroVideo.scss hardcodes that 16:9 ratio to size the
 * player to 85% of the window without letterboxing it. Replacing one with a different
 * ratio does not crop or distort anything, but a wider-than-16:9 asset renders inside a
 * box taller than the picture, and the play-button overlay is sized to the box, so clicks
 * on the dead strips land on it instead of passing through.
 */
export const READY_MODULE_VIDEOS = Object.freeze({
  ASSESS: Object.freeze({
    'en-us': `${ASSET_BASE}/ready_module_assess_en_us.mp4`,
    'es-mx': `${ASSET_BASE}/ready_module_assess_es_mx.mp4`,
  }),
  TUTOR_K_3: Object.freeze({
    'en-us': `${ASSET_BASE}/ready_module_tutor_k_3_en_us.mp4`,
    'es-mx': `${ASSET_BASE}/ready_module_tutor_k_3_es_mx.mp4`,
  }),
  TUTOR_4_8: Object.freeze({
    'en-us': `${ASSET_BASE}/ready_module_tutor_4_8_en_us.mp4`,
    'es-mx': `${ASSET_BASE}/ready_module_tutor_4_8_es_mx.mp4`,
  }),
})

/**
 * Ceiling passed to StudentVideo's isValidDuration, which gates every one of its playback
 * completion fallbacks — the backup timer and the near-end currentTime check both go quiet
 * for anything it rejects, leaving only the native ended event, which StudentVideo's own
 * comments record as unreliable on Chrome OS.
 *
 * The assets above run 92-109s, so they are all over StudentVideo's 90s default. If a video
 * here is ever replaced with a longer one, raise this to match or the fallbacks disable
 * themselves again, silently, and the failure shows up as a student sitting in front of a
 * stopped video.
 */
export const READY_MODULE_VIDEO_MAX_DURATION_SECONDS = 180
